<div class="container-fluid">
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h5><span style="padding-right:10px"></span> <i class="fa fa-edit"></i> <b>Vehicle Type {{lblHeading}}</b></h5>
    </div>
  </div>
  <hr />

  <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
        <!--<div class="row">-->
        <!-- Vehicle Type Options -->     
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="form-group col-md-12">
                <label>
                  <strong>Code<a class="red-asterik">*</a> </strong>
                  <span *ngIf="isDup" class="text-danger">Duplicate Codes are not allowed</span>
                </label>
                <input type="text" name="code" formControlName="code" class="form-control"
                       [ngClass]="{'error':form.controls.code.invalid && form.controls.code.dirty, 'noerror': form.controls.code.valid && form.controls.code.dirty}"
                       title="Codes must be unique. Main sort order if group_code and sort_order not used." />
                <div class="form-control-feedback text-danger text-small"
                     *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                  <p *ngIf="form.controls.code.errors.required">Code is required</p>
                  <p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12 characters.</p>
                </div>
              </div>
              <!--<div class="form-group col-md-6">
                <label><strong>Min Passengers </strong></label>
                <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" onKeyPress="if(this.value.length==3)return false;" autocomplete="off" name="passengers_min" formControlName="passengers_min" min="1" max="50" title="The minimum number of passengers." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.passengers_min.invalid && form.controls.passengers_min.dirty ||form.controls.passengers_min.touched">
                  <p *ngIf="form.controls.passengers_min.errors?.required">The minimum number of passengers is required</p>
                  <p *ngIf="form.controls.passengers_min.errors?.min || form.controls.passengers_min.errors?.max">Passengers minimum must be between 1 and 100</p>
                  <p *ngIf="form.controls.passengers_min.errors?.checked">Passengers minimum must be between 1 and 100</p>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label><strong>Max Passengers </strong></label>
                <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" onKeyPress="if(this.value.length==3) return false;" autocomplete="off" maxLength="3" name="passengers_max" formControlName="passengers_max" [ngClass]="{'error':form.controls.passengers_max.invalid && form.controls.passengers_max.dirty, 'noerror': form.controls.passengers_max.valid && form.controls.passengers_max.dirty}" min="1" max="200" title="The maximum number of passengers." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.passengers_max.invalid && form.controls.passengers_max.dirty ||form.controls.passengers_max.touched">
                  <p *ngIf="form.controls.passengers_max.errors?.required">The maximum number of passengers is required</p>
                  <p *ngIf="form.controls.passengers_max.errors?.min || form.controls.passengers_max.errors?.max">Passengers maximum must be between 1 and 200</p>
                </div>
              </div>-->
            </div>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="form-group col-md-12">
                <label><strong>Description</strong></label>
                <input type="text" class="form-control" name="description" formControlName="description" [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}" title="Free text description of the entity occurrence." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.description.invalid && form.controls.description.dirty">
                  <p *ngIf="form.controls.description.errors.required">Description is required</p>
                  <p *ngIf="form.controls.description.errors.maxlength">Description must not be more than 100 characters.</p>
                </div>
              </div>

              <!--<div class="form-group col-md-12">
                <label>
                  <strong>Passengers </strong>
                </label>
                <input type="text" name="passengers" formControlName="passengers" class="form-control"
                       [ngClass]="{'error':form.controls.passengers.invalid && form.controls.passengers.dirty, 'noerror': form.controls.passengers.valid && form.controls.passengers.dirty}"
                       title="The number of passengers in words." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.passengers.invalid && form.controls.passengers.dirty">
                  <p *ngIf="form.controls.passengers.errors.required">Passengers is required</p>
                  <p *ngIf="form.controls.passengers.errors.maxlength">Passengers must not be more than 50 characters.</p>
                </div>
              </div>-->
              <!--<div class="form-group col-md-4">
                <label><strong>Group Code * </strong></label>
                <input class="form-control form-control" type="text" name="group_code" formControlName="group_code" title="Allows user to group codes. By default, all rows will belong to group A.">
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
                  <p *ngIf="form.controls.group_code.errors.required">Group code is required</p>
                  <p *ngIf="form.controls.group_code.errors.maxlength">Group Code must not be more than 12 characters.</p>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label><strong>Display When * </strong></label>
                <select class="form-control form-control" id="invCat" [(ngModel)]="selectedDisplay" (change)="onSelectChange()" name="display_ind" formControlName="display_ind" title="Indicates where it is used on dropdowns or lists.">
                  <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label><strong>Sort Order * </strong></label>
                <select id="sort_order" class="form-control" name="sort_order" formControlName="sort_order" style="width:100%;" title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
                  <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}</option>
                </select>
              </div>-->
            </div>
          </div>
          <!--Rearrangement-->
          <div class="col-12" style="margin:5px auto;">
            <div class="row">
              <div class="form-group col-md">
                <label>
                  <strong>Passengers </strong>
                </label>
                <input type="text" name="passengers" formControlName="passengers" class="form-control"
                       [ngClass]="{'error':form.controls.passengers.invalid && form.controls.passengers.dirty, 'noerror': form.controls.passengers.valid && form.controls.passengers.dirty}"
                       title="The number of passengers in words." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.passengers.invalid && form.controls.passengers.dirty">
                  <p *ngIf="form.controls.passengers.errors.required">Passengers is required</p>
                  <p *ngIf="form.controls.passengers.errors.maxlength">Passengers must not be more than 50 characters.</p>
                </div>
              </div>

              <div class="form-group col-md">
                <label><strong>Min Passengers </strong></label>
                <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" onKeyPress="if(this.value.length==3)return false;" autocomplete="off" name="passengers_min" formControlName="passengers_min" min="1" max="50" title="The minimum number of passengers." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.passengers_min.invalid && form.controls.passengers_min.dirty ||form.controls.passengers_min.touched">
                  <p *ngIf="form.controls.passengers_min.errors?.required">The minimum number of passengers is required</p>
                  <p *ngIf="form.controls.passengers_min.errors?.min || form.controls.passengers_min.errors?.max">Passengers minimum must be between 1 and 100</p>
                  <p *ngIf="form.controls.passengers_min.errors?.checked">Passengers minimum must be between 1 and 100</p>
                </div>
              </div>
              <div class="form-group col-md">
                <label><strong>Max Passengers </strong></label>
                <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" onKeyPress="if(this.value.length==3) return false;" autocomplete="off" maxLength="3" name="passengers_max" formControlName="passengers_max" [ngClass]="{'error':form.controls.passengers_max.invalid && form.controls.passengers_max.dirty, 'noerror': form.controls.passengers_max.valid && form.controls.passengers_max.dirty}" min="1" max="200" title="The maximum number of passengers." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.passengers_max.invalid && form.controls.passengers_max.dirty ||form.controls.passengers_max.touched">
                  <p *ngIf="form.controls.passengers_max.errors?.required">The maximum number of passengers is required</p>
                  <p *ngIf="form.controls.passengers_max.errors?.min || form.controls.passengers_max.errors?.max">Passengers maximum must be between 1 and 200</p>
                </div>
              </div>

            </div>
          </div>
          <!--End Rearrangement-->

        

                <!-- Sorting and Displaying -->
                <div class="col-12">
                  <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
                    <legend class="scheduler-border tsk-display blackcontrol">Sorting And Displaying</legend> 
                    <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="control-label col-md-12 pull-right">
                            <strong class="" style ="">Sort Order<a class="red-asterik">*</a>&nbsp; </strong>
                          </label>
                          <div class="col-md-12">
                            <select id="sort_order" class="form-control" name="sort_order" formControlName="sort_order" style="" title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
                              <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="control-label col-sm-12">
                            <strong>Group Code<a class="red-asterik">*</a>&nbsp; </strong>
                          </label>
                          <div class="col-sm-12">
                            <input type="text" class="form-control" name="group_code" formControlName="group_code" style="height:38px!important;" [ngClass]="{'error':form.controls.group_code.invalid && form.controls.group_code.dirty, 'noerror': form.controls.group_code.valid && form.controls.group_code.dirty}" title="Allows user to group codes. By default, all rows will belong to group A.">
                            <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
                              <p *ngIf="form.controls.group_code.errors.required">Group Code is required</p>
                              <p *ngIf="form.controls.group_code.errors.maxlength">Group Code must not be more than 12 characters.</p>
                            </div>
                          </div>
      
                        </div>
                        <div class="col-md-3">
                          <label class="control-label col-sm-12">
                            <strong style="">Display When<a class="red-asterik">*</a>&nbsp; </strong>
                          </label>
                          <div class="col-sm-12">
                            <select class="form-control" id="invCat" [(ngModel)]="selectedDisplay" (change)="onSelectChange()" name="display_ind" formControlName="display_ind" style="" title="Indicates where it is used on dropdowns or lists.">
                              <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
                            </select>
                          </div>
                        </div>
        
                        <div class="col-md-3">
      
                          <div class="form-check form-check-inline">
                            <br/>
                            <br/>
                            <label><strong style="">Active?&nbsp; </strong></label>
                            <input class="form-control input-sm" type="checkbox" id="is_active" value="is_active" formControlName="is_active" title="An indicator to control if the row will appear on a list or in a search. Can be used to indicate logically deleted.">
                          </div>
                        </div>
                      </div>
                    </div> 
                  </fieldset>
                </div>
                <!-- End of Sorting and Displayings -->

          <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;">
            <dl style="width:460px;">
              <dt style="width:40px;">Created</dt>
              <dd [innerHTML]="audit.created"></dd>
              <dt style="width:46px;">Updated</dt>
              <dd [innerHTML]="audit.updated"></dd>
            </dl>
          </div>

        </div>

        
        <!-- End -->

        <hr>
        <div class="col-md-12">
          <br>
          <button title="Save change(s)" type="submit" id="btnSave" [disabled]="!form.valid"
                  class="btn btn-md btn-success pull-right" style="width:10%; margin-left:10px; ">
            <i class="fa fa-save"></i>
            Save
          </button>
          <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/vehicle/type/list']"
                  class="btn btn-md btn-info pull-right" style="width:10%; margin-left:10px; ">
            <i class="fa fa-arrow-circle-left"></i> Back
          </button>
        </div>
      </form>
  </div>
</div>  
</div>
<!--End Container -->
